export class ImpuestoPercepcion{

  leyenda: string;
  leyendaSimple: string;
  valor: number;
  tipoValor: number;
  codigo: number;
  baseCalculo: number;
  observacion: string;
}
